import { render, staticRenderFns } from "./cc.vue?vue&type=template&id=187f1495&scoped=true&"
import script from "./cc.vue?vue&type=script&lang=js&"
export * from "./cc.vue?vue&type=script&lang=js&"
import style0 from "./cc.css?vue&type=style&index=0&id=187f1495&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187f1495",
  null
  
)

export default component.exports